export default __webpack_public_path__ + "static/media/main_logo.82f44772.png";